/**
 * License plate formats for 195 countries.
 * Each entry: { code, name, format, placeholder, flag }
 * - code: ISO 3166-1 alpha-2
 * - name: country name in English
 * - format: regex-like description or visual hint
 * - placeholder: example plate
 * - flag: emoji flag
 */
const PLATE_FORMATS = [
  { code: 'AF', name: 'Afghanistan', placeholder: '1-1234 Kabul', flag: '🇦🇫' },
  { code: 'AL', name: 'Albania', placeholder: 'AA 123 BB', flag: '🇦🇱' },
  { code: 'DZ', name: 'Algeria', placeholder: '12345-123-16', flag: '🇩🇿' },
  { code: 'AD', name: 'Andorra', placeholder: 'A1234', flag: '🇦🇩' },
  { code: 'AO', name: 'Angola', placeholder: 'LD-12-34-AB', flag: '🇦🇴' },
  { code: 'AG', name: 'Antigua and Barbuda', placeholder: 'A 1234', flag: '🇦🇬' },
  { code: 'AR', name: 'Argentina', placeholder: 'AB 123 CD', flag: '🇦🇷' },
  { code: 'AM', name: 'Armenia', placeholder: '12 AB 123', flag: '🇦🇲' },
  { code: 'AU', name: 'Australia', placeholder: 'ABC 123', flag: '🇦🇺' },
  { code: 'AT', name: 'Austria', placeholder: 'W 12345 A', flag: '🇦🇹' },
  { code: 'AZ', name: 'Azerbaijan', placeholder: '10-AA-123', flag: '🇦🇿' },
  { code: 'BS', name: 'Bahamas', placeholder: 'AB1234', flag: '🇧🇸' },
  { code: 'BH', name: 'Bahrain', placeholder: '123456', flag: '🇧🇭' },
  { code: 'BD', name: 'Bangladesh', placeholder: 'Dhaka A 12-3456', flag: '🇧🇩' },
  { code: 'BB', name: 'Barbados', placeholder: 'B 1234', flag: '🇧🇧' },
  { code: 'BY', name: 'Belarus', placeholder: '1234 AB-1', flag: '🇧🇾' },
  { code: 'BE', name: 'Belgium', placeholder: '1-ABC-234', flag: '🇧🇪' },
  { code: 'BZ', name: 'Belize', placeholder: 'A-01234', flag: '🇧🇿' },
  { code: 'BJ', name: 'Benin', placeholder: 'AB 1234 BJ', flag: '🇧🇯' },
  { code: 'BT', name: 'Bhutan', placeholder: 'BP-1-1234', flag: '🇧🇹' },
  { code: 'BO', name: 'Bolivia', placeholder: '1234 ABC', flag: '🇧🇴' },
  { code: 'BA', name: 'Bosnia and Herzegovina', placeholder: 'A12-A-123', flag: '🇧🇦' },
  { code: 'BW', name: 'Botswana', placeholder: 'B 123 ABC', flag: '🇧🇼' },
  { code: 'BR', name: 'Brazil', placeholder: 'ABC1D23', flag: '🇧🇷' },
  { code: 'BN', name: 'Brunei', placeholder: 'KA 1234', flag: '🇧🇳' },
  { code: 'BG', name: 'Bulgaria', placeholder: 'CB 1234 AB', flag: '🇧🇬' },
  { code: 'BF', name: 'Burkina Faso', placeholder: '11 A 1234 BF', flag: '🇧🇫' },
  { code: 'BI', name: 'Burundi', placeholder: 'A 1234 A', flag: '🇧🇮' },
  { code: 'CV', name: 'Cabo Verde', placeholder: 'AB-12-34', flag: '🇨🇻' },
  { code: 'KH', name: 'Cambodia', placeholder: '1A 1234', flag: '🇰🇭' },
  { code: 'CM', name: 'Cameroon', placeholder: 'CE 1234 A', flag: '🇨🇲' },
  { code: 'CA', name: 'Canada', placeholder: 'ABCD 123', flag: '🇨🇦' },
  { code: 'CF', name: 'Central African Republic', placeholder: 'AB 1234', flag: '🇨🇫' },
  { code: 'TD', name: 'Chad', placeholder: 'AB 1234 TD', flag: '🇹🇩' },
  { code: 'CL', name: 'Chile', placeholder: 'ABCD-12', flag: '🇨🇱' },
  { code: 'CN', name: 'China', placeholder: '京A12345', flag: '🇨🇳' },
  { code: 'CO', name: 'Colombia', placeholder: 'ABC 123', flag: '🇨🇴' },
  { code: 'KM', name: 'Comoros', placeholder: '123 A 12', flag: '🇰🇲' },
  { code: 'CG', name: 'Congo', placeholder: '123 A 12', flag: '🇨🇬' },
  { code: 'CD', name: 'Congo (DRC)', placeholder: '1234 AA 123', flag: '🇨🇩' },
  { code: 'CR', name: 'Costa Rica', placeholder: 'ABC-123', flag: '🇨🇷' },
  { code: 'CI', name: "Côte d'Ivoire", placeholder: '1234 AB 01', flag: '🇨🇮' },
  { code: 'HR', name: 'Croatia', placeholder: 'ZG 1234-AB', flag: '🇭🇷' },
  { code: 'CU', name: 'Cuba', placeholder: 'ABC 123', flag: '🇨🇺' },
  { code: 'CY', name: 'Cyprus', placeholder: 'ABC 123', flag: '🇨🇾' },
  { code: 'CZ', name: 'Czech Republic', placeholder: '1A2 3456', flag: '🇨🇿' },
  { code: 'DK', name: 'Denmark', placeholder: 'AB 12 345', flag: '🇩🇰' },
  { code: 'DJ', name: 'Djibouti', placeholder: '12345 DJ', flag: '🇩🇯' },
  { code: 'DM', name: 'Dominica', placeholder: 'A1234', flag: '🇩🇲' },
  { code: 'DO', name: 'Dominican Republic', placeholder: 'A123456', flag: '🇩🇴' },
  { code: 'EC', name: 'Ecuador', placeholder: 'ABC-1234', flag: '🇪🇨' },
  { code: 'EG', name: 'Egypt', placeholder: 'أ ب ج 1234', flag: '🇪🇬' },
  { code: 'SV', name: 'El Salvador', placeholder: 'P 123-456', flag: '🇸🇻' },
  { code: 'GQ', name: 'Equatorial Guinea', placeholder: 'GE-12345', flag: '🇬🇶' },
  { code: 'ER', name: 'Eritrea', placeholder: '12345', flag: '🇪🇷' },
  { code: 'EE', name: 'Estonia', placeholder: '123 ABC', flag: '🇪🇪' },
  { code: 'SZ', name: 'Eswatini', placeholder: 'MSD 123 AB', flag: '🇸🇿' },
  { code: 'ET', name: 'Ethiopia', placeholder: 'AA 12345', flag: '🇪🇹' },
  { code: 'FJ', name: 'Fiji', placeholder: 'AB 123', flag: '🇫🇯' },
  { code: 'FI', name: 'Finland', placeholder: 'ABC-123', flag: '🇫🇮' },
  { code: 'FR', name: 'France', placeholder: 'AB-123-CD', flag: '🇫🇷' },
  { code: 'GA', name: 'Gabon', placeholder: '1234 A 01', flag: '🇬🇦' },
  { code: 'GM', name: 'Gambia', placeholder: 'BJL 1234 A', flag: '🇬🇲' },
  { code: 'GE', name: 'Georgia', placeholder: 'AB-123-CD', flag: '🇬🇪' },
  { code: 'DE', name: 'Germany', placeholder: 'M AB 1234', flag: '🇩🇪' },
  { code: 'GH', name: 'Ghana', placeholder: 'GR 1234-12', flag: '🇬🇭' },
  { code: 'GR', name: 'Greece', placeholder: 'ABC-1234', flag: '🇬🇷' },
  { code: 'GD', name: 'Grenada', placeholder: 'A 1234', flag: '🇬🇩' },
  { code: 'GT', name: 'Guatemala', placeholder: 'P 123ABC', flag: '🇬🇹' },
  { code: 'GN', name: 'Guinea', placeholder: 'AB 1234 A', flag: '🇬🇳' },
  { code: 'GW', name: 'Guinea-Bissau', placeholder: 'AB-12-34', flag: '🇬🇼' },
  { code: 'GY', name: 'Guyana', placeholder: 'ABC 1234', flag: '🇬🇾' },
  { code: 'HT', name: 'Haiti', placeholder: 'AB 12345', flag: '🇭🇹' },
  { code: 'HN', name: 'Honduras', placeholder: 'AA 1234', flag: '🇭🇳' },
  { code: 'HU', name: 'Hungary', placeholder: 'ABC-123', flag: '🇭🇺' },
  { code: 'IS', name: 'Iceland', placeholder: 'AB123', flag: '🇮🇸' },
  { code: 'IN', name: 'India', placeholder: 'MH 01 AB 1234', flag: '🇮🇳' },
  { code: 'ID', name: 'Indonesia', placeholder: 'B 1234 ABC', flag: '🇮🇩' },
  { code: 'IR', name: 'Iran', placeholder: '12 A 123 IR 45', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraq', placeholder: '12345 Baghdad', flag: '🇮🇶' },
  { code: 'IE', name: 'Ireland', placeholder: '201-D-12345', flag: '🇮🇪' },
  { code: 'IL', name: 'Israel', placeholder: '123-45-678', flag: '🇮🇱' },
  { code: 'IT', name: 'Italy', placeholder: 'AB 123 CD', flag: '🇮🇹' },
  { code: 'JM', name: 'Jamaica', placeholder: '1234 AB', flag: '🇯🇲' },
  { code: 'JP', name: 'Japan', placeholder: '品川 500 あ 1234', flag: '🇯🇵' },
  { code: 'JO', name: 'Jordan', placeholder: '12-12345', flag: '🇯🇴' },
  { code: 'KZ', name: 'Kazakhstan', placeholder: '123 ABC 01', flag: '🇰🇿' },
  { code: 'KE', name: 'Kenya', placeholder: 'KAA 123A', flag: '🇰🇪' },
  { code: 'KI', name: 'Kiribati', placeholder: 'KI 1234', flag: '🇰🇮' },
  { code: 'KP', name: 'North Korea', placeholder: '평양 12-3456', flag: '🇰🇵' },
  { code: 'KR', name: 'South Korea', placeholder: '12가 1234', flag: '🇰🇷' },
  { code: 'KW', name: 'Kuwait', placeholder: '12345 / 1', flag: '🇰🇼' },
  { code: 'KG', name: 'Kyrgyzstan', placeholder: '01 AB 123', flag: '🇰🇬' },
  { code: 'LA', name: 'Laos', placeholder: '1234', flag: '🇱🇦' },
  { code: 'LV', name: 'Latvia', placeholder: 'AB-1234', flag: '🇱🇻' },
  { code: 'LB', name: 'Lebanon', placeholder: 'A 123456', flag: '🇱🇧' },
  { code: 'LS', name: 'Lesotho', placeholder: 'A 123 ABC', flag: '🇱🇸' },
  { code: 'LR', name: 'Liberia', placeholder: 'ABC 1234', flag: '🇱🇷' },
  { code: 'LY', name: 'Libya', placeholder: '12345', flag: '🇱🇾' },
  { code: 'LI', name: 'Liechtenstein', placeholder: 'FL 12345', flag: '🇱🇮' },
  { code: 'LT', name: 'Lithuania', placeholder: 'ABC 123', flag: '🇱🇹' },
  { code: 'LU', name: 'Luxembourg', placeholder: 'AB 1234', flag: '🇱🇺' },
  { code: 'MG', name: 'Madagascar', placeholder: '1234 AB', flag: '🇲🇬' },
  { code: 'MW', name: 'Malawi', placeholder: 'AB 1234', flag: '🇲🇼' },
  { code: 'MY', name: 'Malaysia', placeholder: 'WKL 1234', flag: '🇲🇾' },
  { code: 'MV', name: 'Maldives', placeholder: 'A1A 1234', flag: '🇲🇻' },
  { code: 'ML', name: 'Mali', placeholder: 'AB 1234 BKO', flag: '🇲🇱' },
  { code: 'MT', name: 'Malta', placeholder: 'ABC 123', flag: '🇲🇹' },
  { code: 'MH', name: 'Marshall Islands', placeholder: 'MH 1234', flag: '🇲🇭' },
  { code: 'MR', name: 'Mauritania', placeholder: '1234 AB 01', flag: '🇲🇷' },
  { code: 'MU', name: 'Mauritius', placeholder: 'AB 12', flag: '🇲🇺' },
  { code: 'MX', name: 'Mexico', placeholder: 'ABC-12-34', flag: '🇲🇽' },
  { code: 'FM', name: 'Micronesia', placeholder: 'FSM 1234', flag: '🇫🇲' },
  { code: 'MD', name: 'Moldova', placeholder: 'ABC 123', flag: '🇲🇩' },
  { code: 'MC', name: 'Monaco', placeholder: '1234', flag: '🇲🇨' },
  { code: 'MN', name: 'Mongolia', placeholder: '1234 УБА', flag: '🇲🇳' },
  { code: 'ME', name: 'Montenegro', placeholder: 'PG AB 123', flag: '🇲🇪' },
  { code: 'MA', name: 'Morocco', placeholder: '12345-A-1', flag: '🇲🇦' },
  { code: 'MZ', name: 'Mozambique', placeholder: 'MAA-123-AB', flag: '🇲🇿' },
  { code: 'MM', name: 'Myanmar', placeholder: '1A/1234', flag: '🇲🇲' },
  { code: 'NA', name: 'Namibia', placeholder: 'N 12345 W', flag: '🇳🇦' },
  { code: 'NR', name: 'Nauru', placeholder: 'NR 1234', flag: '🇳🇷' },
  { code: 'NP', name: 'Nepal', placeholder: 'Ba 1 Pa 1234', flag: '🇳🇵' },
  { code: 'NL', name: 'Netherlands', placeholder: 'AB-123-C', flag: '🇳🇱' },
  { code: 'NZ', name: 'New Zealand', placeholder: 'ABC123', flag: '🇳🇿' },
  { code: 'NI', name: 'Nicaragua', placeholder: 'M 123 456', flag: '🇳🇮' },
  { code: 'NE', name: 'Niger', placeholder: 'AB 1234 NE', flag: '🇳🇪' },
  { code: 'NG', name: 'Nigeria', placeholder: 'ABC-123-AB', flag: '🇳🇬' },
  { code: 'MK', name: 'North Macedonia', placeholder: 'SK 1234 AB', flag: '🇲🇰' },
  { code: 'NO', name: 'Norway', placeholder: 'AB 12345', flag: '🇳🇴' },
  { code: 'OM', name: 'Oman', placeholder: '1234 AB', flag: '🇴🇲' },
  { code: 'PK', name: 'Pakistan', placeholder: 'ABC-1234', flag: '🇵🇰' },
  { code: 'PW', name: 'Palau', placeholder: '1234', flag: '🇵🇼' },
  { code: 'PS', name: 'Palestine', placeholder: '1234567', flag: '🇵🇸' },
  { code: 'PA', name: 'Panama', placeholder: 'AB1234', flag: '🇵🇦' },
  { code: 'PG', name: 'Papua New Guinea', placeholder: 'ABC 123', flag: '🇵🇬' },
  { code: 'PY', name: 'Paraguay', placeholder: 'ABCD 123', flag: '🇵🇾' },
  { code: 'PE', name: 'Peru', placeholder: 'ABC-123', flag: '🇵🇪' },
  { code: 'PH', name: 'Philippines', placeholder: 'ABC 1234', flag: '🇵🇭' },
  { code: 'PL', name: 'Poland', placeholder: 'WA 12345', flag: '🇵🇱' },
  { code: 'PT', name: 'Portugal', placeholder: 'AA-12-BB', flag: '🇵🇹' },
  { code: 'QA', name: 'Qatar', placeholder: '123456', flag: '🇶🇦' },
  { code: 'RO', name: 'Romania', placeholder: 'B 123 ABC', flag: '🇷🇴' },
  { code: 'RU', name: 'Russia', placeholder: 'А123БВ 77', flag: '🇷🇺' },
  { code: 'RW', name: 'Rwanda', placeholder: 'RAA 123A', flag: '🇷🇼' },
  { code: 'KN', name: 'Saint Kitts and Nevis', placeholder: 'A 1234', flag: '🇰🇳' },
  { code: 'LC', name: 'Saint Lucia', placeholder: 'A 1234', flag: '🇱🇨' },
  { code: 'VC', name: 'Saint Vincent', placeholder: 'A 1234', flag: '🇻🇨' },
  { code: 'WS', name: 'Samoa', placeholder: '12345', flag: '🇼🇸' },
  { code: 'SM', name: 'San Marino', placeholder: 'A1234', flag: '🇸🇲' },
  { code: 'ST', name: 'São Tomé and Príncipe', placeholder: 'AB-12-34', flag: '🇸🇹' },
  { code: 'SA', name: 'Saudi Arabia', placeholder: 'أ ب ج 1234', flag: '🇸🇦' },
  { code: 'SN', name: 'Senegal', placeholder: 'AB 1234 SN', flag: '🇸🇳' },
  { code: 'RS', name: 'Serbia', placeholder: 'BG 123-AB', flag: '🇷🇸' },
  { code: 'SC', name: 'Seychelles', placeholder: 'S 1234', flag: '🇸🇨' },
  { code: 'SL', name: 'Sierra Leone', placeholder: 'ABC 1234', flag: '🇸🇱' },
  { code: 'SG', name: 'Singapore', placeholder: 'SBA 1234A', flag: '🇸🇬' },
  { code: 'SK', name: 'Slovakia', placeholder: 'BA 123 AB', flag: '🇸🇰' },
  { code: 'SI', name: 'Slovenia', placeholder: 'LJ AB-123', flag: '🇸🇮' },
  { code: 'SB', name: 'Solomon Islands', placeholder: 'A 1234', flag: '🇸🇧' },
  { code: 'SO', name: 'Somalia', placeholder: 'MOG 1234', flag: '🇸🇴' },
  { code: 'ZA', name: 'South Africa', placeholder: 'CA 123-456', flag: '🇿🇦' },
  { code: 'SS', name: 'South Sudan', placeholder: 'SS 12345', flag: '🇸🇸' },
  { code: 'ES', name: 'Spain', placeholder: '1234 BCD', flag: '🇪🇸' },
  { code: 'LK', name: 'Sri Lanka', placeholder: 'WP AB-1234', flag: '🇱🇰' },
  { code: 'SD', name: 'Sudan', placeholder: '12345', flag: '🇸🇩' },
  { code: 'SR', name: 'Suriname', placeholder: 'AB-1234', flag: '🇸🇷' },
  { code: 'SE', name: 'Sweden', placeholder: 'ABC 12A', flag: '🇸🇪' },
  { code: 'CH', name: 'Switzerland', placeholder: 'ZH 123456', flag: '🇨🇭' },
  { code: 'SY', name: 'Syria', placeholder: '123456', flag: '🇸🇾' },
  { code: 'TW', name: 'Taiwan', placeholder: 'ABC-1234', flag: '🇹🇼' },
  { code: 'TJ', name: 'Tajikistan', placeholder: '01 AB 1234', flag: '🇹🇯' },
  { code: 'TZ', name: 'Tanzania', placeholder: 'T 123 ABC', flag: '🇹🇿' },
  { code: 'TH', name: 'Thailand', placeholder: 'กก 1234', flag: '🇹🇭' },
  { code: 'TL', name: 'Timor-Leste', placeholder: 'TL 12345', flag: '🇹🇱' },
  { code: 'TG', name: 'Togo', placeholder: 'AB 1234 TG', flag: '🇹🇬' },
  { code: 'TO', name: 'Tonga', placeholder: '12345', flag: '🇹🇴' },
  { code: 'TT', name: 'Trinidad and Tobago', placeholder: 'ABC 1234', flag: '🇹🇹' },
  { code: 'TN', name: 'Tunisia', placeholder: '123 TU 1234', flag: '🇹🇳' },
  { code: 'TR', name: 'Turkey', placeholder: '34 ABC 1234', flag: '🇹🇷' },
  { code: 'TM', name: 'Turkmenistan', placeholder: 'AB 123 AB', flag: '🇹🇲' },
  { code: 'TV', name: 'Tuvalu', placeholder: '1234', flag: '🇹🇻' },
  { code: 'UG', name: 'Uganda', placeholder: 'UAA 123A', flag: '🇺🇬' },
  { code: 'UA', name: 'Ukraine', placeholder: 'AA 1234 BB', flag: '🇺🇦' },
  { code: 'AE', name: 'United Arab Emirates', placeholder: 'A 12345', flag: '🇦🇪' },
  { code: 'GB', name: 'United Kingdom', placeholder: 'AB12 CDE', flag: '🇬🇧' },
  { code: 'US', name: 'United States', placeholder: 'ABC 1234', flag: '🇺🇸' },
  { code: 'UY', name: 'Uruguay', placeholder: 'ABC 1234', flag: '🇺🇾' },
  { code: 'UZ', name: 'Uzbekistan', placeholder: '01 A 123 AB', flag: '🇺🇿' },
  { code: 'VU', name: 'Vanuatu', placeholder: '1234', flag: '🇻🇺' },
  { code: 'VA', name: 'Vatican City', placeholder: 'SCV 12345', flag: '🇻🇦' },
  { code: 'VE', name: 'Venezuela', placeholder: 'ABC-123', flag: '🇻🇪' },
  { code: 'VN', name: 'Vietnam', placeholder: '30A-123.45', flag: '🇻🇳' },
  { code: 'YE', name: 'Yemen', placeholder: '12345', flag: '🇾🇪' },
  { code: 'ZM', name: 'Zambia', placeholder: 'ABC 1234', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbabwe', placeholder: 'ABC 1234', flag: '🇿🇼' },
];

/**
 * Get plate format info for a country code.
 * Falls back to a generic format if not found.
 */
export function getPlateFormat(countryCode) {
  return PLATE_FORMATS.find(p => p.code === countryCode) || {
    code: countryCode || '??',
    name: 'Unknown',
    placeholder: 'ABC 1234',
    flag: '🏳️',
  };
}

/**
 * Get all countries sorted alphabetically by name.
 */
export function getAllCountries() {
  return [...PLATE_FORMATS].sort((a, b) => a.name.localeCompare(b.name));
}

export default PLATE_FORMATS;
